import useBondEndorsementSubmitHandlers from "./useBondEndorsementSubmitHandlers";

/** Approve-bonds endorsement submit/release — delegates to shared bond endorsement handlers. */
export default function useApproveBondsEndorsementHandlers(props) {
  const { handleReleaseRider, handleSubmitEndorsementRequest } =
    useBondEndorsementSubmitHandlers(props);
  return { handleReleaseRider, handleSubmitEndorsementRequest };
}
